import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Gauge } from "lucide-react";

interface IFurnaceVentJackSize {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function FurnaceVentJackSize(props: IFurnaceVentJackSize) {
    const { value, onChange, loading } = { ...props };
    const [jackSize, setJackSize] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setJackSize(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setJackSize(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Jack Size
            </Typography>

            <Select
                placeholder="Select jack size"
                value={jackSize}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Gauge size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="4 inch">4 inch</Option>
                <Option value="5 inch">5 inch</Option>
                <Option value="6 inch">6 inch</Option>
                <Option value="7 inch">7 inch</Option>
                <Option value="TBD">TBD</Option>
            </Select>
        </Box>
    );
}
